var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-row',{attrs:{"type":"flex","justify":_vm.justify}},_vm._l((_vm.list),function(item,key){return _c('van-col',{key:key,class:item.name},[_c('base-link',{attrs:{"data":item}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }